module.exports = __webpack_public_path__ + "static/media/style-icon-active.8db1b409.svg";